import type { LabelColor, LabelRefDto } from '@tms/shared';
import { cn } from '../../lib/cn';

/** One token pair per palette entry, so labels read in both themes. */
export const LABEL_COLOR_STYLES: Record<LabelColor, string> = {
  gray: 'bg-sunken text-ink-muted',
  blue: 'bg-accent-soft text-accent-fg',
  green: 'bg-pass-soft text-pass',
  amber: 'bg-block-soft text-block',
  red: 'bg-fail-soft text-fail',
  purple: 'bg-accent-soft text-accent-fg',
};

/** Dot used in pickers, where the colour has to show before the name. */
export const LABEL_DOT_STYLES: Record<LabelColor, string> = {
  gray: 'bg-ink-subtle',
  blue: 'bg-accent-fg',
  green: 'bg-pass',
  amber: 'bg-block',
  red: 'bg-fail',
  purple: 'bg-accent',
};

export const LabelChip = ({
  label,
  className,
}: {
  label: LabelRefDto;
  className?: string;
}) => (
  <span
    className={cn(
      'inline-flex max-w-40 items-center truncate rounded-md px-1.5 py-0.5 text-[12px] font-medium',
      LABEL_COLOR_STYLES[label.color],
      className,
    )}
  >
    {label.name}
  </span>
);

export const LabelDot = ({ color, className }: { color: LabelColor; className?: string }) => (
  <span className={cn('size-2 shrink-0 rounded-full', LABEL_DOT_STYLES[color], className)} />
);
